export function niceJoin(items) {
  if (!items || items.length === 0) return '';
  if (items.length === 1) return items[0];
  if (items.length === 2) return `${items[0]} and ${items[1]}`;

  const lastItem = items[items.length - 1];
  const allButLast = items.slice(0, -1);
  return `${allButLast.join(', ')}, and ${lastItem}`;
}